import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";
import { customLog } from "../../variables/Variables";
import { Button, Modal, FormControl } from "react-bootstrap";
import Switch from "react-switch";
//css
import "../../assets/css/maincss.css";
import "../../assets/css/header.css";
import LocalizedStrings from "react-localization";
import { isBoolean } from "lodash";
let localizationStrings = new LocalizedStrings({
  en: {
    authenticationHeader: "Authentication Mode",
    authenticationTitle: "Enable device authentication (User / Admin account)",
    authenticationDescription:
      "*Enabling this will allow you to receive a notification and email for approving when a member is logging in from a new device",
    cancelBtnTitle: "Cancel",
    disableBtnTitle: "Disable",
    enableBtnTitle: "Enable",
    popupTitle: "Confirm",
    popupMessage_1: "Are you sure you want to ",
    popupMessage_2: " the device authentication?",
    popupMessageEnable: "enable",
    popupMessageDisable: "disable",
  },
  ja: {
    authenticationHeader: "認証モード",
    authenticationTitle: "デバイス認証を有効にする (メンバー/管理者)",
    authenticationDescription:
      "*メンバーが新たなデバイスでログインしようとした時に、承認要求メールを受け取ることができます。",
    cancelBtnTitle: "キャンセル",
    disableBtnTitle: "無効",
    enableBtnTitle: "有効",
    popupTitle: "確認",
    popupMessage_1: "",
    popupMessage_2: "のアクセスを有効にしますか？",
    popupMessageEnable: "有効",
    popupMessageDisable: "無効",
  },
  es: {
    authenticationHeader: "Modo de Autenticación",
    authenticationTitle:
      "Habilitar autenticación de dispositivo (Cuenta de Usuario / Administrador)",
    authenticationDescription:
      "*Habilitar esto te permitirá recibir una notificación y un correo electrónico para aprobar cuando un miembro inicie sesión desde un nuevo dispositivo",
    cancelBtnTitle: "Cancelar",
    disableBtnTitle: "Desactivar",
    enableBtnTitle: "Habilitar",
    popupTitle: "Confirmar",
    popupMessage_1: "¿Estás seguro de que quieres ",
    popupMessage_2: " la autenticación del dispositivo?",
    popupMessageEnable: "habilitar",
    popupMessageDisable: "desactivar",
  },
});

class AuthenticationSetting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      authenticationMode: false,
    };

    //? all function
    this.handleChange = this.handleChange.bind(this);
    this.handlePopupOpen = this.handlePopupOpen.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
  }

  componentWillMount() {
    //! LANGUAGE SETTING
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
            showPopup: false,
          });
        });
    }

    //check for superAdminSettings under groupAccounts for AuthenticationMode
    fire
      .database()
      .ref("groupAccounts/" + auth.currentUser.uid)
      .child("superAdminSettings")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          if (snapshot.val().isAuthenticationMode === true) {
            this.setState({
              authenticationMode: true,
            });
          } else {
            this.setState({
              authenticationMode: false,
            });
          }
        } else {
          this.setState({
            authenticationMode: false,
          });
        }
      });
  }

  handlePopupOpen() {
    this.setState({ showPopup: true });
  }

  handlePopupClose() {
    this.setState({ showPopup: false });
  }

  handleChange() {
    let currentAuthenticationMode = this.state.authenticationMode;
    this.setState(
      {
        authenticationMode: !currentAuthenticationMode,
      },
      () => {
        const groupAccountsDB = fire
          .database()
          .ref("groupAccounts/" + auth.currentUser.uid);

        groupAccountsDB.once("value").then((snapshot) => {
          if (snapshot.exists) {
            if (
              snapshot.val().isAuthenticationMode !== undefined ||
              snapshot.val().isAuthenticationMode !== null
            ) {
              groupAccountsDB.child("superAdminSettings").update({
                isAuthenticationMode: this.state.authenticationMode,
              });
            }
          }
        });
        // console.log('Current authentication mode is: ' + this.state.authenticationMode);
      }
    );

    this.handlePopupClose();
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    return (
      <div style={{ width: "100%" }}>
        {/* pop-up appear when user tries to turn on authenticationMode */}
        <Modal
          show={this.state.showPopup}
          onHide={this.handlePopupClose}
          dialogClassName="modal-fixed-400px"
          style={{ display: "flex", alignItems: "center" }}
        >
          <Modal.Header closeButton>
            <Modal.Title>{localizationStrings.popupTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <p
                className="lightFont"
                style={{
                  textAlign: "left",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                }}
              >
                {localizationStrings.popupMessage_1}
                <strong>
                  {this.state.authenticationMode
                    ? localizationStrings.popupMessageDisable
                    : localizationStrings.popupMessageEnable}
                </strong>
                {localizationStrings.popupMessage_2}
              </p>
            </div>
            <br />
            <div style={{ display: "flex", justifyContent: "right" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "50%",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  marginLeft: "auto",
                  marginRight: "0px",
                }}
              >
                <Button
                  className={
                    this.state.authenticationMode
                      ? "toggleAuthBtn colorRed"
                      : "toggleAuthBtn colorGreen"
                  }
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={this.handleChange}
                >
                  {this.state.authenticationMode
                    ? localizationStrings.disableBtnTitle
                    : localizationStrings.enableBtnTitle}
                </Button>
                <Button
                  className={
                    localizationStrings.getLanguage() === "ja"
                      ? "toggleAuthCancelBtnJap"
                      : "toggleAuthCancelBtn"
                  }
                  onClick={this.handlePopupClose}
                >
                  {localizationStrings.cancelBtnTitle}
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <header
          style={{
            fontSize: "18px",
            fontWeight: "bold",
            marginBottom: "80px",
          }}
        >
          {localizationStrings.authenticationHeader}
        </header>

        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div>
              <p>{localizationStrings.authenticationTitle}</p>
            </div>
            <div>
              <Switch
                onChange={this.handlePopupOpen}
                checked={this.state.authenticationMode}
                id="normal-switch"
              />
            </div>
          </div>
          <div style={{ width: "70%" }}>
            <p style={{ fontStyle: "italic", fontWeight: "100", color: "red" }}>
              {localizationStrings.authenticationDescription}
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default AuthenticationSetting;
